import React from "react";

import Badge from "@components/badge";

import styles from "./BadgeNew.scss";

const BadgeNew = () => (
  <Badge className={styles["badge-new"]} size="small">
    NEW
  </Badge>
);

export default BadgeNew;
